<template>
  <div class="page-course">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/major`">专业信息</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/major/course/list`">专业课程</el-breadcrumb-item>
        <el-breadcrumb-item>{{ data.Name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content course-content">
        <div class="brief">
          <div class="left">
            <img @error="imgError" :src="data.Cover" :alt="data.Name" />
          </div>
          <div class="right">
            <h3>{{ data.Name }}</h3>
            <p>作者：{{ data.author }}</p>
            <p>出版时间{{ data.publishDate }}</p>
            <p>出版社：{{ data.press }}</p>
            <p>面向对象：{{ data.scope }}</p>
            <p>关联岗位：{{ data.Jobs }}</p>
            <p>相关证书：{{ certif }}</p>
          </div>
        </div>
        <div class="content-wrap">
          <column-header2 :data="{ name: '课程简介' }"></column-header2>
          <div class="content">{{ data.Introduction }}</div>
          <column-header2 :data="{ name: '课程目录' }"></column-header2>
          <div class="content">
            <div class="directory" :class="showAllDirectory ? 'all' : ''" v-html="data.directory"></div>
            <a class="toggle" @click="showAllDirectory = !showAllDirectory">
              <template v-if="showAllDirectory">
                收起全部
                <i class="el-icon-arrow-up"></i>
              </template>
              <template v-else>
                展开全部
                <i class="el-icon-arrow-down"></i>
              </template>
            </a>
          </div>
          <column-header2 :data="{ name: '关联岗位' }"></column-header2>
          <div class="content">{{ data.Jobs }}</div>
          <column-header2 :data="{ name: '相关证书' }"></column-header2>
          <div class="content">
            <div class="certif" v-for="(item, i) in data.certif" :key="i">
              <div class="left">
                <h3>{{ item.name }}</h3>
                <p>{{ item.desc }}</p>
              </div>
              <div class="right">
                <img @error="imgError" :src="item.pic" :alt="item.name" />
              </div>
            </div>
          </div>
          <column-header2 :data="{ name: '考核能力' }"></column-header2>
          <div class="content ability">
            <span v-for="(item, i) in data.ability" :key="i">
              <i class="el-icon-success"></i>
              {{ item }}
            </span>
          </div>
          <column-header2 :data="{ name: '课程下载' }"></column-header2>
          <div v-if="data.File && data.File.length" class="attach">
            <p v-for="file in data.File" :key="file.Id">
              <i class="el-icon-link"></i>
              <a class="file" :href="`/files/${model.FileFilePath}`" :download="file.FileName">{{ file.FileName }}</a>
              <a class="btn" :href="`/files/${model.FileFilePath}`" :download="file.FileName">点击下载</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail } from "api/app";
import ColumnHeader from "_c/ColumnHeader2";
export default {
  data() {
    return {
      showAllDirectory: false,
      data: {},
      metaData: {
        name: "学徒岗位"
      }
    };
  },
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader
  },
  methods: {
    loadData() {
      getDetail({ name: "Curriculum", id: this.$route.params.id }).then(res => {
        this.data = res || {};
      });
    },
    init() {
      this.loadData();
    }
  },
  computed: {
    certif() {
      if (this.data.certif && this.data.certif.length) {
        return this.data.certif.map(item => item.name).join("、");
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.page-course {
  background: #f6f6f9;
  padding-bottom: 40px;
  .course-content {
    padding: 0 0 40px 0;
    .brief {
      background: url(~assets/img/feature/watermarker2.png) no-repeat 95% top;
      background-size: 200px auto;
      padding: 32px 72px;
      display: flex;
      border-bottom: 1px solid #eee;
      .left {
        width: 175px;
        height: 235px;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 24px;
      }
      .right {
        flex: 1;
        h3 {
          font-size: 20px;
          font-weight: 500;
          padding: 8px 0 16px 0;
        }
        p {
          line-height: 22px;
          padding-bottom: 8px;
          color: #999;
        }
      }
    }
    ::v-deep .comp-column-header {
      padding-top: 24px;
    }
    .content-wrap {
      margin: 0 72px;
      padding-bottom: 40px;
      .content {
        color: #666;
        line-height: 32px;
        font-size: 15px;
        .directory {
          max-height: 160px;
          overflow: hidden;
        }
        .directory.all {
          max-height: initial;
          height: auto;
          overflow: visible;
        }
        .toggle {
          color: $primary-color;
          cursor: pointer;
          &:hover {
            color: $link-active-color;
          }
        }
      }
      .ability {
        display: flex;
        flex-wrap: wrap;
        padding-right: 72px;
        span {
          width: 33%;
          i {
            color: #5cc7cf;
            padding-right: 5px;
          }
        }
      }
      .certif {
        display: flex;
        margin-right: 72px;
        .left {
          flex: 1;
          h3 {
            font-weight: 600;
          }
        }
        .right {
          width: 339px;
          height: 225px;
          margin-left: 60px;
        }
      }
    }
  }
}
</style>
